import type { ProjectDto } from '../application/dto/ProjectDto';
import './ProjectStatusBadge.css';

const STATUS_LABEL: Record<ProjectDto['status'], string> = {
  licensed: 'دارای پروانه بهره‌برداری',
  exploration: 'در حال اکتشاف',
  active: 'در حال بهره‌برداری',
  completed: 'تکمیل‌شده',
  planned: 'در دست برنامه‌ریزی'
};

export interface ProjectStatusBadgeProps {
  status: ProjectDto['status'];
}

export function ProjectStatusBadge({ status }: ProjectStatusBadgeProps) {
  return <span className={`dma-project-status dma-project-status--${status}`}>{STATUS_LABEL[status]}</span>;
}
